
var path = require('path')
let exporter = {
}

export const list = []

async function importAll (r) {
  let id = 0
  r.keys().forEach(key => {
    let filename = path.basename(key).replace('.glb', '')
    exporter[filename] = r(key)
    list.push({
      _id: id++,
      name: filename,
      url: r(key)
    })
  })
  return exporter
}

// importAll(require.context('~/components/Pages', true, /\.vue$/, 'sync'), 'sync')
importAll(require.context('file-loader!./', true, /\.glb$/, 'sync'), 'sync')

export default exporter
